module.exports = "/img/24.7a9ffa.webp";